import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppSelector } from "@redux/hooks";
import { selectProviderOnboarding } from "@user-management-context/write/application/use-cases/provider-onboarding/selectors/provider-onboarding-selectors";
import { ProviderOnboarding } from "./provider-onboarding.content";
import { useProviderOnboarding } from "./use-provider-onboarding";
import { fullSchema, type ProviderOnboardingFormInputs } from "./form-validation/full-form.schema";
import { defaultValues } from "./form-validation/shared";

export const ProviderOnboardingContainer = () => {
  const { processing } = useAppSelector(selectProviderOnboarding);
  const form = useForm<ProviderOnboardingFormInputs>({ resolver: yupResolver(fullSchema), defaultValues, mode: "onSubmit" });
  const { onboard } = useProviderOnboarding(form);

  return <ProviderOnboarding form={form} onSubmit={form.handleSubmit(onboard)} submitting={processing === "pending"} />;
};
